import { ChangeDetectorRef, AfterContentChecked, Component, Inject, Injectable, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { WrapperStandardFilter } from '../../common/models/wrapper.model';
import { GenericService } from '../../services/base/generic-service';
import { GenericCFLViewFunctions } from './generic-cfl-view-functions';
import { NgxIndexedDBService, ObjectStoreMeta, ObjectStoreSchema } from 'ngx-indexed-db';
import { BranchCFLModel, BranchCFLModelSAP } from 'src/app/core/models/masters/BranchCFL.model';
import { shareReplay, Subscription } from 'rxjs';



@Component({
  selector: 'app-generic-cfl-view',
  templateUrl: './generic-cfl-view.component.html',
  styleUrls: ['./generic-cfl-view.component.css']
})
@Injectable()
export class GenericCflViewComponent<T> extends GenericCFLViewFunctions<T> implements OnInit, OnDestroy {
  @ViewChild('table')
  table!: MatTable<Element>;
  dataSource!: any;
  matData: any;
  arrMultupleSelectedData: any[] = [];
  checked: boolean = true;
  isDone: boolean = true;
  selectedKey: string = '';
  displayedColumns: string[] = ['select', 'accounttypename', 'accountcode', 'accountname'];
  dataSource1: any[] = [
    {
      'accounttypename': 'Down Payment Payables', 'accountcode': '0023425351', 'accountname': 'Account Name'
    }
  ];
  filterUpdateSubscription!: Subscription;

  constructor(
    Repository: GenericService<T>, routr: Router,
    public matDialogCfl: MatDialog, public matDialogRefCfl: MatDialogRef<GenericCflViewComponent<T>>,
    @Inject(MAT_DIALOG_DATA) private data: any, private dbService: NgxIndexedDBService) {
    super(Repository, routr, matDialogCfl, matDialogRefCfl);
    this.matData = { ...data };
  }
  ngOnInit(): void {

    this.setIsCflSingleSelection = this.matData.isItSingleSelection;
    this.setFormTitle = this.matData.title;
    this.setListViewDataSourceURL = this.matData.dataSourceUrl;
    this.setDisplayedColumnsNamesList = this.matData.displayedColumn;
    this.selectedKey = this.getDisplayedColumnsNamesList[1];
    this.setSortColumn = this.matData.sortColumn;
    this.setCflFilterArray = this.matData.filter;
    this.setIsItCflEnumList = this.matData.isItEnumList,
      this.setCflEnumObjectNameToDisplay = this.matData.EnumObjectNameToDisplay,
      this.setCflEnumStoreName = this.matData.EnumStoreName,
      this.setCflEnumDataToStoreInDB = this.matData.EnumDataToStoreInDB;
    this.setCFLNumberType = this.matData.cflNumberType;
    this.setCFLStringType = this.matData.cflStringType;
    this.setCFLRequestDataWithCode = this.matData.cflRequestDataWithCode;
    this.setCFLRequestDataInnerObjName = this.matData.cflRequestDataInnerArrayName;
    this.setCFLIsCancel = this.matData.cflIsCancel;

    if (this.getIsItCflEnumList == true) {
      this.generateObjectStoreData();
    } else {//api
      if (this.matData.filter.length > 0) {
        this.getRequestData.RequestData = this.matData.filter;
      }
      else if (this.getCFLRequestDataWithCode) {
        this.getRequestData.RequestData = this.matData.cflRequestDataWithCode;
      }
      this.getRequestData.SortColumn = this.matData.sortColumn;

      (async () => {
        await this.PopulateListViewForOnScrollPagination();
        this.dataSource = new MatTableDataSource(this.getListViewDataSourceOnScrollPagination);
      })();
    }


    // On chip removal
    this.filterUpdateSubscription = this.filterUpdateSubject.asObservable().subscribe(res => {
      if (res) {
        this.dataSource = new MatTableDataSource(this.getListViewDataSourceOnScrollPagination);
        this.filterUpdateSubject.next(false);
      }
    })
  }
  ngDoCheck() {
    // this.dataSource = new MatTableDataSource(this.getListViewDataSourceOnScrollPagination);
    // this.setSelectedData();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.getCFLRequestDataInnerObjName) {
        for (let i = 0; i < this.getCFLRequestDataInnerObjName.contactEmployees; i++) {
          this.dataSource = new MatTableDataSource(this.getListViewDataSourceOnScrollPagination);
        }
      }
      if (this.getIsItCflEnumList == true) {
        this.getDataFromIndexDB();
      }
      else {
        this.dataSource = new MatTableDataSource(this.getListViewDataSourceOnScrollPagination);
        this.dataSource.filteredData = [];
        console.log(this.getListViewDataSourceOnScrollPagination);
        this.setSelectedData();
      }
    }, 1000);
  }
  // ngAfterViewCheked() {
  //   this.dataSource = new MatTableDataSource(this.getListViewDataSourceOnScrollPagination);
  //   //this.dataSource.filteredData = [];
  // }

  //set selected data
  private setSelectedData() {
    if (this.getIsCflSingleSelection == false) {//mulitple selection - if (this.isItMultipleSelection)
      //let arrSelectedData = this.matData.selectedData.split(',');
      let arrSelectedData = this.matData.selectedData;
      this.arrMultupleSelectedData = new Array();
      arrSelectedData.forEach((innerEle: any) => {
        let arrFilteredData = this.getListViewDataSourceOnScrollPagination.filter((s: any) => s[this.matData.sortColumn] === innerEle.bplid || innerEle.wtaxcode);
        arrFilteredData.forEach((innerEle: any) => {
          innerEle.isSelected = true;
          this.arrMultupleSelectedData.push(innerEle);
        });
      });
    } else {//single selection
      let arrFilteredData = this.getListViewDataSourceOnScrollPagination.filter((s: any) => s[this.matData.sortColumn] === this.matData.selectedData);
      arrFilteredData.forEach((innerEle: any) => {
        innerEle.isSelected = true;
      });
    }
  }
  onChangeRadio(event: MatRadioChange) {
    this.getListViewDataSourceOnScrollPagination.forEach((element: any) => {
      if (element == event.value) {
        element.isSelected = true;
        this.isDone = false;
      } else {
        element.isSelected = false;
        this.isDone = false;
      }
      this.setCflSelectedData = event.value;
    });
  }
  onChangeCheckBox(event: MatCheckboxChange, element: any) {
    if (event.checked) {
      element.isSelected = event.checked;
      this.arrMultupleSelectedData.push(element);
    } else {
      let indx = this.arrMultupleSelectedData!.indexOf(element);
      if (indx != -1) {
        this.arrMultupleSelectedData.splice(indx, 1);
      }
    }
    this.setCflSelectedData = this.arrMultupleSelectedData;
  }
  toggleClass() {
    this.active = !this.active;
  }
  //For Enum List - Index DB
  generateObjectStoreData() {
    const storeSchema: ObjectStoreMeta = {
      store: this.getCflEnumStoreName,
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: []
    };
    this.dbService.deleteObjectStore(this.getCflEnumStoreName)
    this.dbService.createObjectStore(storeSchema);
    this.setDataToIndexDB(this.getCflEnumDataToStoreInDB);
  }
  setDataToIndexDB(EntryFormDataSource: any) {
    //add enum list api response object in index DB
    this.dbService.clear(this.getCflEnumStoreName).subscribe((successDeleted) => {
      console.log('success? ', successDeleted);
    });

    this.dbService.add(this.getCflEnumStoreName, EntryFormDataSource).subscribe((key) => {
      console.log('key: ', key);
    });
  }
  getDataFromIndexDB() {
    this.dbService.getAll(this.getCflEnumStoreName).subscribe((enumData: any) => {
      console.log(enumData)
      this.setListViewDataSourceOnScrollPagination = enumData[0][this.getCflEnumObjectNameToDisplay];
      this.dataSource = new MatTableDataSource(this.getListViewDataSourceOnScrollPagination);
      this.setSelectedData();
    });
  }
  //Find
  getActualString(str: string) {
    let finalResult = str.charAt(0).toUpperCase() + str.slice(1);
    return finalResult.replace(/([A-Z])/g, " $1").trim();
  }

  getColType(col: string): string {
    if (col === 'series' || col === 'docEntry') {
      return 'numerics';
    }
    if (this.getListViewDataSourceOnScrollPagination && this.getListViewDataSourceOnScrollPagination.length > 0) {
      const val = (this.getListViewDataSourceOnScrollPagination[0] as any)[col];
      if (typeof val === 'number') {
        return 'numerics';
      }
    }
    return 'alphabets';
  }

  async checkFilterDataType(column: string, from: string, to: string, labelType: string) {

    let filter: WrapperStandardFilter = new WrapperStandardFilter();
    if (!this._filterArray || this._filterArray.length === 0) {
      this._filterArray = this.matData?.filter ? [...this.matData.filter] : [];
    }
    this._filterArray = this._filterArray.filter((f: any) => f.Key !== column);
    filter.Key = column;
    filter.OperatorType = from && to ? ">=" : "startswith";
    filter.Value = from;
    this.setFilterArray = filter;

    filter = new WrapperStandardFilter();
    filter.Key = column;
    filter.OperatorType = from && to ? "<=" : "endswith";
    filter.Value = to;
    this.setFilterArray = filter;

    this.getRequestData.PageSize = 1;
    this.setListViewDataSourceOnScrollPagination = [];
    if (from || to) {
      this.onCreateFilterChip(column, from, to, labelType);
    }
    await this.PopulateListViewForOnScrollPagination();
    this.dataSource = await new MatTableDataSource(this.getListViewDataSourceOnScrollPagination);
    await this.setSelectedData();
  }


  async onClickOfGenericColumnSortCFL(sortColumn: string, isAcending: boolean) {
    //this.onTableScroll();
    this.getRequestData.PageSize = 1;
    this.getRequestData.SortColumn = sortColumn;
    this.getRequestData.IsAcending = isAcending;
    this.active = !this.active;
    this.setListViewDataSourceOnScrollPagination = [];
    // setTimeout(() => {
    //   this.dataSource = new MatTableDataSource(this.getListViewDataSourceOnScrollPagination);
    //   this.setSelectedData();
    // }, 1500);
    await this.PopulateListViewForOnScrollPagination();
    this.dataSource = new MatTableDataSource(this.getListViewDataSourceOnScrollPagination);
    this.setSelectedData();

  };
  //Pagination Scroll
  // async onTableScroll() {
  // //  alert()
  //   if (this.pageIndex < this.getPageRecordCount) { 
  //     // await this.setSelectedData();
  //     this.pageIndex = this.getCurrentPage + 1;
  //     this.pageSize += this.getPageSize;
  //     this.getRequestData.SortColumn = this.matData.sortColumn;
  //     this.getRequestData.PageSize = this.pageIndex;
  //     this.setAppendDataSource = true;
  //     await this.PopulateListViewForOnScrollPagination();
  //     this.dataSource = new MatTableDataSource(this.getListViewDataSourceOnScrollPagination);
  //     this.setSelectedData();
  //   }

  // }


  async onTableScroll(event: any) {
    //alert('Hi')
    const tableViewHeight = event.target.offsetHeight // viewport
    const tableScrollHeight = event.target.scrollHeight // length of all table
    const scrollLocation = event.target.scrollTop; // how far user scrolled

    const buffer = 10;

    const limit = tableScrollHeight - tableViewHeight - buffer;
    if (scrollLocation > limit) {
      if (this.pageIndex < this.getPageRecordCount) {
        this.pageIndex = this.getCurrentPage + 1;
        this.pageSize += this.getPageSize;
        this.getRequestData.SortColumn;
        this.getRequestData.PageSize = this.pageIndex;
        this.setAppendDataSource = true;
        this.setIsPagination = true;
        await this.PopulateListViewForOnScrollPagination();
        this.dataSource = new MatTableDataSource(this.getListViewDataSourceOnScrollPagination);
        this.setSelectedData();

      }
    }

  }


  ngOnDestroy(): void {
    this.filterUpdateSubject.unsubscribe();
  }
}
